export type CardVerification = {
  id: string
  clientId: string
  comment: string
  expiry: string
  fileNames: string
  cardType: string
  isCard: boolean
  mask: string
  status: string
  token: string
  type: string
  verified: boolean
  updatedAt: string
  createdAt: string
  browserFileNames: string[]
  client: Client
}

export type Client = {
  clientId: string
  email: string
  fullName: string
  firstName: string
  middleName: string
  lastName: string
  country: string
  verified: boolean
  isTest: boolean
  isPremium: boolean
}

export type CardVerificationResponse = {
  items: CardVerification[]
  total: number
}

export type CardVerificationRequest = {
  limit: number
  page: number
  orderBy: string
  orderDirection: string
  searchText: { [key: string]: string }
  searchedColumn: string
  filters?: {
    status?: string[] | null
  }
}

export enum CardVerificationStatuses {
  CLIENT_PURSE_STATUS_UNVERIFIED = 'unverified',
  CLIENT_PURSE_STATUS_INVALID = 'invalid',
  CLIENT_PURSE_STATUS_PENDING = 'pending',
  CLIENT_PURSE_STATUS_VERIFIED = 'verified',
  CLIENT_PURSE_STATUS_REJECTED = 'rejected',
}
